var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.494,
    height: 21.607,
    viewBox: "0 0 21.494 21.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45879",
    "data-name": "Group 45879",
    transform: "translate(-5023 2731.107)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89738",
    "data-name": "Path 89738",
    d: "M10.738,4.386c0,.212.012.423.012.635q0,2.66,0,5.32c0,.382.044.416.391.534.909.308,1.824.6,2.731.91l.4.14",
    transform: "translate(5023.009 -2730)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89739",
    "data-name": "Path 89739",
    d: "M10.433.75c-.364.057-.733.065-1.1.116A9.658,9.658,0,0,0,5.8,2.072,9.94,9.94,0,0,0,1.265,7.586a9.807,9.807,0,0,0-.5,2.681,9.986,9.986,0,0,0,.473,3.562,9.632,9.632,0,0,0,1.805,3.293,9.829,9.829,0,0,0,3.339,2.617,10.176,10.176,0,0,0,3.612.978,9.889,9.889,0,0,0,5-.913,9.689,9.689,0,0,0,2.276-1.479,9.984,9.984,0,0,0,2.7-11.4,9.867,9.867,0,0,0-2.662-3.707,9.782,9.782,0,0,0-3.466-1.971A9.1,9.1,0,0,0,11.165.774c-.236,0-.472-.016-.708-.024",
    transform: "translate(5023 -2731)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonth);
export default __webpack_public_path__ + "static/media/month.aef8101af1b77ac3537894d2a87e4a6d.svg";
export { ForwardRef as ReactComponent };